import * as firebase from "firebase/app";
import constants from "../constants";

export default class FirebaseDependant {
  constructor() {
    if (firebase.apps && firebase.apps.length === 0) {
      firebase.initializeApp(constants.firebaseConfig);
    }
  }
}
